import { c as _c } from "react/compiler-runtime";
import { FormField } from '@/components/Molecules/FormField/FormField';
import { useSearchContext } from '@/contexts/SearchContext';
import useTranslation from '@/hooks/useTranslation';
import type { FilterBounds } from 'bnef';
import type { ChangeEvent, FC } from 'react';
import { useState } from 'react';
import styles from './YearRangeFilter.module.css';
export const YearRangeFilter: FC<{
  name: string;
  label: string;
  min?: number | string;
  max?: number | string;
}> = t0 => {
  const $ = _c(44);
  const {
    name,
    label,
    min,
    max
  } = t0;
  const {
    t
  } = useTranslation();
  const {
    activeFilters,
    setActiveFilter
  } = useSearchContext();
  const activeFilter = activeFilters[name] as FilterBounds | undefined;
  const [currentValueFrom, setCurrentValueFrom] = useState(activeFilter?.gte ?? "");
  const [currentValueTo, setCurrentValueTo] = useState(activeFilter?.lte ?? "");
  let t1;
  if ($[0] !== min) {
    t1 = min && parseInt(min.toString().slice(0, 4));
    $[0] = min;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const minValue = t1;
  let t2;
  if ($[2] !== max) {
    t2 = max && parseInt(max.toString().slice(0, 4));
    $[2] = max;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const maxValue = t2;
  let t3;
  if ($[4] !== name || $[5] !== setActiveFilter) {
    t3 = (from, to) => {
      const gte = from?.length === 4 ? from : undefined;
      const lte = to?.length === 4 ? to : undefined;
      if (!gte && !lte) {
        setActiveFilter(name, null);
        return;
      }
      const filterValue = {};
      if (gte) {
        filterValue.gte = gte;
      }
      if (lte) {
        filterValue.lte = lte;
      }
      setActiveFilter(name, filterValue);
    };
    $[4] = name;
    $[5] = setActiveFilter;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const updateValues = t3;
  let t4;
  if ($[7] !== t) {
    t4 = t("SearchFilter.filterNames.from");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = `${name}[gte]`;
  const t6 = minValue ? `Min: ${minValue}` : "YYYY";
  let t7;
  if ($[9] !== currentValueTo || $[10] !== maxValue || $[11] !== minValue || $[12] !== updateValues) {
    t7 = event => {
      let value = parseInt(event.target.value);
      const from_0 = event.target.value.toString();
      let to_0 = currentValueTo;
      const len = from_0.length;
      if (len === 4) {
        if (minValue && value < minValue) {
          value = minValue;
        }
        if (maxValue && value > maxValue) {
          value = maxValue;
        }
        if (currentValueTo && parseInt(currentValueTo) < value) {
          setCurrentValueTo(value.toString());
          to_0 = value.toString();
        }
      }
      setCurrentValueFrom(value.toString());
      if (len === 4 || len === 0) {
        updateValues(from_0, to_0);
      }
    };
    $[9] = currentValueTo;
    $[10] = maxValue;
    $[11] = minValue;
    $[12] = updateValues;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== currentValueFrom || $[15] !== maxValue || $[16] !== minValue || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t8 = <input className={styles.input} aria-label={t4} type="number" value={currentValueFrom} name={t5} placeholder={t6} min={minValue} max={maxValue} onChange={t7} />;
    $[14] = currentValueFrom;
    $[15] = maxValue;
    $[16] = minValue;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span>—</span>;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t) {
    t10 = t("SearchFilter.filterNames.to");
    $[23] = t;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const t11 = `${name}[lte]`;
  const t12 = maxValue ? `Max: ${maxValue}` : "YYYY";
  let t13;
  if ($[25] !== currentValueFrom || $[26] !== maxValue || $[27] !== minValue || $[28] !== updateValues) {
    t13 = event_0 => {
      let value_0 = parseInt(event_0.target.value);
      const to_1 = event_0.target.value.toString();
      let from_1 = currentValueFrom;
      const len_0 = to_1.length;
      if (len_0 === 4) {
        if (minValue && value_0 < minValue) {
          value_0 = minValue;
        }
        if (maxValue && value_0 > maxValue) {
          value_0 = maxValue;
        }
        if (currentValueFrom && parseInt(currentValueFrom) > value_0) {
          setCurrentValueFrom(value_0.toString());
          from_1 = value_0.toString();
        }
      }
      setCurrentValueTo(value_0.toString());
      if (len_0 === 4 || len_0 === 0) {
        updateValues(from_1, to_1);
      }
    };
    $[25] = currentValueFrom;
    $[26] = maxValue;
    $[27] = minValue;
    $[28] = updateValues;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== currentValueTo || $[31] !== maxValue || $[32] !== minValue || $[33] !== t10 || $[34] !== t11 || $[35] !== t12 || $[36] !== t13) {
    t14 = <input className={styles.input} aria-label={t10} type="number" value={currentValueTo} name={t11} min={minValue} max={maxValue} placeholder={t12} onChange={t13} />;
    $[30] = currentValueTo;
    $[31] = maxValue;
    $[32] = minValue;
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== t14 || $[39] !== t8) {
    t15 = <div className={styles.fields}>{t8}{t9}{t14}</div>;
    $[38] = t14;
    $[39] = t8;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== label || $[42] !== t15) {
    t16 = <FormField label={label} asGroup={true}>{t15}</FormField>;
    $[41] = label;
    $[42] = t15;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  return t16;
};